import useEntityTable from "hooks/useEntityTable";
import {
  listWebsites,
  createWebsite,
  updateWebsite,
  deleteWebsite,
  activateWebsite,
  deactivateWebsite,
} from "api/endpoints/websites";

// Stable api reference for useEntityTable.
const websitesApi = {
  list: listWebsites,
  create: createWebsite,
  update: updateWebsite,
  remove: deleteWebsite,
  activate: activateWebsite,
  deactivate: deactivateWebsite,
};

// Data + actions for the Websites table.
export default function useWebsitesTable() {
  return useEntityTable({ api: websitesApi, entityName: "Website" });
}
